import styled from "@emotion/styled";
import { color } from "metabase/lib/colors";

export const StepDescription = styled.div`
  color: ${color("text-medium")};
  margin-top: 0.875rem;
`;
